// extracted by mini-css-extract-plugin
module.exports = {"Div":"ChooseCharScreen_Div__k-HTH","Title":"ChooseCharScreen_Title__23UuX"};